import { ChooseCampaignBodyWrapper, TakeoverBodyLabel } from './styled';
import { ChooseCampaignTable } from './chooseCampaignTable';
import { ChooseCampaignSearch } from './ChooseCampaignSearch';

export const ChooseCampaignBody = () => {
  return (
    <ChooseCampaignBodyWrapper data-test="choose-campaign-takeover-body">
      <TakeoverBodyLabel data-test="choose-campaign-body-label">
        Select the campaign for your new experiment
      </TakeoverBodyLabel>
      <ChooseCampaignSearch />
      <ChooseCampaignTable />
    </ChooseCampaignBodyWrapper>
  );
};
